export interface Testimonial {
  id: string;
  name: string;
  avatar: string;
  rating: number;
  content: string;
  date: string;
  lotteryType: string;
}

export const testimonials: Testimonial[] = [
  {
    id: 't1',
    name: '王先生',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20male%20portrait%20headshot%20on%20clean%20white%20background%2C%20business%20casual%2C%20friendly%20smile%2C%20studio%20lighting%2C%20simple%20composition&width=100&height=100&seq=avatar-male-01&orientation=squarish',
    rating: 5,
    content: '用BB彩票APP两年多了，很方便，中过好几次小奖，提现秒到账！客服态度也很好，值得信赖的平台。',
    date: '2024-08-05',
    lotteryType: '双色球',
  },
  {
    id: 't2',
    name: '李阿姨',
    avatar: 'https://readdy.ai/api/search-image?query=Middle%20aged%20Chinese%20woman%20portrait%20headshot%20on%20clean%20white%20background%2C%20warm%20smile%2C%20natural%20studio%20lighting%2C%20simple%20elegant%20composition&width=100&height=100&seq=avatar-female-02&orientation=squarish',
    rating: 5,
    content: '儿子帮我下载的，操作很简单，我这个年纪也能轻松使用。每天买几注大乐透，中过三等奖，开心得不得了！',
    date: '2024-08-03',
    lotteryType: '大乐透',
  },
  {
    id: 't3',
    name: '张先生',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20professional%20headshot%20on%20clean%20white%20background%2C%20confident%20expression%2C%20modern%20style%2C%20studio%20lighting%2C%20minimal%20portrait&width=100&height=100&seq=avatar-male-03&orientation=squarish',
    rating: 5,
    content: '快三玩了大半年了，开奖快，到账更快。平台的正规资质让我放心，推荐给了好几个朋友。',
    date: '2024-07-28',
    lotteryType: '快三',
  },
  {
    id: 't4',
    name: '刘女士',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%20headshot%20on%20clean%20white%20background%2C%20bright%20natural%20smile%2C%20casual%20style%2C%20soft%20studio%20lighting%2C%20clean%20composition&width=100&height=100&seq=avatar-female-04&orientation=squarish',
    rating: 4,
    content: '界面设计很清爽，买彩票的流程很顺畅。里面的走势图分析功能对我来说很有用，帮助很大。',
    date: '2024-07-25',
    lotteryType: '福彩3D',
  },
  {
    id: 't5',
    name: '陈大爷',
    avatar: 'https://readdy.ai/api/search-image?query=Senior%20Chinese%20man%20portrait%20headshot%20on%20clean%20white%20background%2C%20gentle%20smile%2C%20casual%20dress%2C%20warm%20studio%20lighting%2C%20classic%20portrait%20style&width=100&height=100&seq=avatar-male-05&orientation=squarish',
    rating: 5,
    content: '退休后每天买几注彩票成了我的乐趣，BB彩票APP让我足不出户就能购彩，非常方便。客服小姑娘声音好听态度好。',
    date: '2024-07-20',
    lotteryType: '排列三',
  },
  {
    id: 't6',
    name: '赵先生',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20man%20business%20portrait%20headshot%20on%20clean%20white%20background%2C%20serious%20yet%20friendly%2C%20corporate%20style%2C%20studio%20lighting%2C%20clean%20minimal%20composition&width=100&height=100&seq=avatar-male-06&orientation=squarish',
    rating: 5,
    content: '我是做数据分析的，BB彩票APP的数据统计功能做得非常专业。历史数据完整，走势图清晰，对我的选号分析帮助极大。',
    date: '2024-07-18',
    lotteryType: '时时彩',
  },
];